'use strict';

module.exports = '2.26.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 335
// module chunks = 0